import { storyblokEditable } from '@storyblok/react/rsc'
import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokVoucherCardType } from '../../model/storyblokTypes.generated'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

import { StoryblokVoucherCardDiscountBadge } from './StoryblokVoucherCardDiscountBadge'
import { StoryblokVoucherCardModal } from './StoryblokVoucherCardModal'

import styles from './StoryblokVoucherCard.module.css'

export const StoryblokVoucherCard: FC<
  StoryblokComponentProps<StoryblokVoucherCardType>
> = ({ blok }) => {
  const modalControls = useOpenableControls()

  return (
    <div
      className={clsx(
        styles['voucher-card-container'],
        blok.isTopDeal && 'bg-light-brand-high',
        !blok.isTopDeal && 'bg-light-brand-medium',
      )}
      {...storyblokEditable(blok)}
    >
      <div className="flex flex-1 flex-col gap-14">
        <div className="flex flex-col items-center gap-2 tablet:items-baseline">
          <StoryblokComponentsRenderer bloks={blok.title} />
          <StoryblokComponentsRenderer bloks={blok.description} />
          <Button
            className="w-full tablet:w-auto"
            onClick={modalControls.handleOpen}
            size="small"
            variant="outlined"
          >
            <FormattedMessage id="voucherBox.label.conditions" />
          </Button>
          <StoryblokVoucherCardModal
            isModalOpen={modalControls.isOpen}
            onCloseModal={modalControls.handleClose}
            {...blok}
          />
        </div>
        {blok.footer ? (
          <StoryblokComponentsRenderer bloks={blok.footer} />
        ) : null}
      </div>
      <StoryblokVoucherCardDiscountBadge
        promoCode={blok.promoCode}
        text={blok.discount}
      />
    </div>
  )
}
